"use client";
import React from "react";
import { Box, Highlight, Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { FiArrowRight } from "@onemind-services-llc/react-icons-ng/fi";
import Image from "next/image";
import HeroImg from "public/about-us/about-banner-img.png";
import PageLayout from "@/layouts/pageLayout";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { HERO_CONSTANTS } from "./constants";

const HeroComp = () => {
  const { title, desc, btnText } = HERO_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Box position="relative" w="100%">
      <Box position="absolute" inset="0" bg={"#2A7BE4"} zIndex={-1}>
        <Image
          src={HeroImg}
          alt="Hero banner"
          fill
          priority
          quality={80}
          style={{ objectFit: "cover" }}
        />
      </Box>
      <Box
        color="white"
        py={{ base: 8, sm: 16 }}
        minH={{ base: "60vh", md: "600px" }}
        display="flex"
        alignItems="center"
      >
        <PageLayout>
          <Stack gap={8} w={{ base: "100%", md: "80%", xl: "70%" }}>
            <Heading as="h1" variant={HeadingVariant}>
              {title}
            </Heading>
            <Stack gap={4}>
              {desc.map((item, index) => (
                <Text
                  key={index}
                  variant={TextVariant}
                  fontSize={{ base: "md", lg: "20px" }}
                >
                  <Highlight
                    query={item.highlight}
                    styles={{ fontWeight: 700, color: "white" }}
                  >
                    {item.text}
                  </Highlight>
                </Text>
              ))}
            </Stack>
            <Button
              onClick={() => scrollToElement("contact-us", 120)}
              variant={"outline"}
              rightIcon={<FiArrowRight />}
              w="fit-content"
            >
              {btnText}
            </Button>
          </Stack>
        </PageLayout>
      </Box>
    </Box>
  );
};

export default HeroComp;
